
import React from 'react';
import { FormattedMessage, useIntl } from '../../util/reactIntl';

import { LayoutComposer, Page, H1, H2, H3, Button } from '../../components';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';
import css from './AboutUsPage.module.css';

// Optimized hero images
import HeroWebp from '../../assets/images/pages/about/IMG_2321 (1).webp';
import HeroPng from '../../assets/images/pages/about/IMG_2321 (1).png';

const AboutUsPage = () => {
  const layoutAreas = `
    topbar
    main
    footer
  `;

  const intl = useIntl();

  return (
    <Page
      className={css.root}
      title={intl.formatMessage({ id: "AboutUsPage.pageTitle" })}
      scrollingDisabled={false}
    >
      <LayoutComposer areas={layoutAreas} className={css.layout}>
        {({ Topbar, Main, Footer }) => (
          <>
            <Topbar as="header" className={css.topbar}>
              <TopbarContainer />
            </Topbar>
            <Main as="main" className={css.main}>
              {/* Hero Section */}
              <section className={css.heroSection}>
                <div className={css.heroContent}>
                  <H3 className={css.heroSubtitle}>
                    <FormattedMessage id="AboutUsPage.heroSubtitle" />
                  </H3>
                  <H1 className={css.heroTitle}>
                    <FormattedMessage id="AboutUsPage.heroTitle" />
                  </H1>
                  <p className={css.heroTagline}>
                    <FormattedMessage id="AboutUsPage.heroTagline" />
                  </p>
                </div>
                <picture className={css.heroImage}>
                  <source srcSet={HeroWebp} type="image/webp" />
                  <img src={HeroPng} alt="Reborn Ireland - Parent community" className={css.image} />
                </picture>
              </section>

              <div className={css.content}>
                {/* Meet the Family Section */}
                <section className={css.familySection}>
                  <H2 className={css.sectionTitle}>
                    <FormattedMessage id="AboutUsPage.familyTitle" />
                  </H2>
                  <p className={css.sectionText}>
                    <FormattedMessage id="AboutUsPage.familyText" />
                  </p>
                </section>

                {/* Mission Section */}
                <section className={css.missionSection}>
                  <H2 className={css.sectionTitle}>
                    <FormattedMessage id="AboutUsPage.missionTitle" />
                  </H2>
                  <p className={css.sectionText}>
                    <FormattedMessage id="AboutUsPage.missionText" />
                  </p>
                </section>

                {/* Values Section */}
                <section className={css.valuesSection}>
                  <H2 className={css.sectionTitle}>
                    <FormattedMessage id="AboutUsPage.valuesTitle" />
                  </H2>
                  <div className={css.valuesGrid}>
                    <div className={css.valueCard}>
                      <H3 className={css.valueName}>
                        <FormattedMessage id="AboutUsPage.valueTrust" />
                      </H3>
                      <p className={css.valueDesc}>
                        <FormattedMessage id="AboutUsPage.valueTrustDesc" />
                      </p>
                    </div>
                    <div className={css.valueCard}>
                      <H3 className={css.valueName}>
                        <FormattedMessage id="AboutUsPage.valueParent" />
                      </H3>
                      <p className={css.valueDesc}>
                        <FormattedMessage id="AboutUsPage.valueParentDesc" />
                      </p>
                    </div>
                    <div className={css.valueCard}>
                      <H3 className={css.valueName}>
                        <FormattedMessage id="AboutUsPage.valueSustain" />
                      </H3>
                      <p className={css.valueDesc}>
                        <FormattedMessage id="AboutUsPage.valueSustainDesc" />
                      </p>
                    </div>
                    <div className={css.valueCard}>
                      <H3 className={css.valueName}>
                        <FormattedMessage id="AboutUsPage.valueHonesty" />
                      </H3>
                      <p className={css.valueDesc}>
                        <FormattedMessage id="AboutUsPage.valueHonestDesc" />
                      </p>
                    </div>
                  </div>
                </section>

                {/* Built With You Section */}
                <section className={css.builtSection}>
                  <H2 className={css.sectionTitle}>
                    <FormattedMessage id="AboutUsPage.builtTitle" />
                  </H2>
                  <p className={css.sectionText}>
                    <FormattedMessage id="AboutUsPage.builtText" />
                  </p>
                </section>

                {/* CTA Section */}
                <section className={css.ctaSection}>
                  <H2 className={css.ctaTitle}>
                    <FormattedMessage id="AboutUsPage.ctaTitle" />
                  </H2>
                  <Button className={css.ctaButton}>
                    <FormattedMessage id="AboutUsPage.ctaButton" />
                  </Button>
                </section>
              </div>
            </Main>
            <Footer>
              <FooterContainer />
            </Footer>
          </>
        )}
      </LayoutComposer>
    </Page>
  );
};

export default AboutUsPage;
